﻿import { AdminMetricCard } from "@/components/admin";
import type { AdminStatusTone } from "@/lib/adminCodeDisplay";
import type { MemberItem } from "@/types.ts";

interface SummaryCardsProps {
  members: MemberItem[];
}

interface MemberSummaryCard {
  title: string;
  value: string;
  badge: string;
  description: string;
  tone: AdminStatusTone;
  icon: string;
}

const SummaryCards = ({ members }: SummaryCardsProps) => {
  const activeCount = members.filter((member) => member.status === "ACTIVE").length;
  const userAccountCount = members.filter((member) => member.accountType === "USER_ACCOUNT").length;
  const seniorCount = members.filter((member) => member.userType === "SENIOR").length;
  const keeperCount = members.filter((member) => member.userType === "GUARDIAN").length;
  const socialCount = members.filter((member) => member.socialConnectedYn === "Y").length;
  const cards: MemberSummaryCard[] = [
    {
      title: "전체 계정",
      value: `${members.length}개`,
      badge: `활성 ${activeCount}개`,
      description: "Senior·Keeper 앱 사용자",
      tone: "blue",
      icon: "ri-team-line",
    },
    {
      title: "USER_ACCOUNT",
      value: `${userAccountCount}개`,
      badge: `소셜 ${socialCount}개`,
      description: "현행 API 관리 대상",
      tone: "blue",
      icon: "ri-shield-user-line",
    },
    {
      title: "Senior",
      value: `${seniorCount}개`,
      badge: "Senior 앱",
      description: "Senior 로그인 계정",
      tone: "teal",
      icon: "ri-user-heart-line",
    },
    {
      title: "Keeper",
      value: `${keeperCount}개`,
      badge: "Keeper 앱",
      description: "Keeper 로그인 계정",
      tone: "violet",
      icon: "ri-user-add-line",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {cards.map((card) => (
        <AdminMetricCard
          key={card.title}
          title={card.title}
          value={card.value}
          badge={card.badge}
          description={card.description}
          tone={card.tone}
          icon={card.icon}
        />
      ))}
    </div>
  );
};

export default SummaryCards;
